var exports = {
  "b": "xcc377c0b--79c514--workTime",
};

module.exports = exports;
